<template>
  <!-- 圈状图 -->
  <div
    :class="className"
    ref="pan"
    :style="{ height: height, width: width }"
  ></div>
</template>

<script>
import echarts from "echarts";
import { deepClone } from "@/assets/js/utils"
require("echarts/theme/macarons");
export default {
  props: {
    className: {
      type: String,
      default: "chat",
    },
    title: {
      type: String,
      default: "chat",
    },
    MeetingStat: {
      type: Object,
      default: {},
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
  },
  data() {
    return {
      delay: false
    }
  },
  watch: {
    MeetingStat: function (val) {
      this.initmeeting_echarts(val);
    },
  },
  created() {
    const that = this
    window.addEventListener("resize", function () {
      if (that.delay) {
        clearTimeout(that.delay);
      }
      that.delay = setTimeout(function () {
        that.initmeeting_echarts(that.MeetingStat);
      }, 20);
    });
  },
  methods: {
    initmeeting_echarts(options) {
      //var myChart = echarts.init(this.$el, "macarons");
      var myChart = echarts.init(this.$refs.pan);
      myChart.resize()
      // console.log(options)
      let index = 0;
      var colorList = ['#73DDFF', '#73ACFF', '#FDD56A', '#FDB36A', '#FD866A', '#9E87FF', '#58D5FF']

      let option = {
        title: {
          text: '',
          x: 'center',
          y: 'center',
          textStyle: {
            fontSize: 20,
            color: "#fff"
          }
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          textStyle: {
            fontSize: 12,
            color: "#00ccff"
          }
        },
        tooltip: {
          trigger: 'item'
        },
        series: [{
          type: 'pie',
          center: ['60%', '50%'],
          radius: ['90%', '45%'],
          clockwise: true,
          avoidLabelOverlap: true,
          hoverOffset: 15,
          itemStyle: {
            normal: {
              color: function (params) {
                return colorList[params.dataIndex]
              }
            }
          },
          label: {
            show: false,
            position: 'inside',
            formatter: '{a|{b}：{d}%}\n{hr|}',
            rich: {
              hr: {
                backgroundColor: 't',
                borderRadius: 3,
                width: 3,
                height: 1,
                padding: [3, 3, 0, -12]
              },
              a: {
                padding: [-30, 15, -20, 15]
              }
            }
          },
          labelLine: {
            normal: {
              length: 20,
              length2: 30,
              lineStyle: {
                width: 1
              }
            }
          },
          data: options.data
        }]
      };
      var that = this;
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.meeting_Stat {
  height: 176px;
}
</style>



// WEBPACK FOOTER //
// src/components/Echarts/CircleChart.vue